import { DiceGameTargetType, diceGameReturnToPlayer } from '.'

export const getDicePayoutConfig = (target: number, targetType: DiceGameTargetType) => {
  const winRate = targetType === DiceGameTargetType.Under ? target : 100 - target

  return {
    winRate: Number(winRate.toFixed(4)),
    multiplier: target >= 100 ? null : Number((diceGameReturnToPlayer / winRate).toFixed(4)),
    target,
    targetType,
  }
}
